module.exports = __webpack_public_path__ + "static/img/40.6063214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/40.jpg
// module id = 8f+R
// module chunks = 1